export default __webpack_public_path__ + "static/media/KN.3f842f73.mp3";